var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-list",class:{'child-expanded' : _vm.hasAChildExpanded}},_vm._l((_vm.partners),function(partner,i){return _c('partner-item',{key:i,attrs:{"partner":partner,"id":i},on:{"toggleState":function($event){return _vm.onToggleState($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }